export default "__VITE_ASSET__294eb42e__"